// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import Sortable from '../../common/sortable';
import SortableItem from './sortableItem';
import MText from '../../common/MText';

const TagSortable = (props) => (
  <div className="d-flex flex-column" style={{ minHeight: 200 }}>
    <div className="d-flex align-items-center py-2 px-3 bg-light border-bottom font-weight-bold">
      <div className="flex-grow-1 d-flex align-items-center" style={{ fontSize: 14 }}>
        <div style={{ width: 40, marginLeft: 15, marginRight: 30 }} />
        <MText
          text="Tag"
          bold
          size={14}
        />
      </div>
      <MText
        text="Total POIs"
        bold
        size={14}
        className="text-center d-flex justify-content-center"
        style={{ width: 100 }}
      />
    </div>

    <Sortable
      data={props.tags}
      handleSort={props.handleSort}
      renderItem={(tag) => <SortableItem tag={tag} />}
    />
  </div>
);

TagSortable.propTypes = {
  tags:       PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  handleSort: PropTypes.func.isRequired,
};

export default TagSortable;
